import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var Item = function Item(_ref) {
  var value = _ref.value,
      description = _ref.description;
  var getClassName = getClassNameFactory("DataCallout");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      descendantName: "item"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "itemValue"
    })
  }, value), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "itemDescription"
    })
  }, description));
};

Item.displayName = "DataCallout.Item";
export default Item;